import React from "react";
import { Close } from "shared/assets/icons";
import { Icon } from "shared/styles";
import { colors } from "shared/styles/constants";

export const MultiplyIcon: React.FC = () => (
  <Icon as={Close} size="xs" color={colors.grey4} />
);
